/**
 * Hud — fixed, non-interactive instrument chrome layered over the whole page:
 * corner ticks, a live UTC readout pinned to Newport Beach's coordinates, and
 * a vertical edge label. Kept low-contrast so it frames rather than competes.
 */
import { useEffect, useState } from "react";

function useUtcClock() {
  const [now, setNow] = useState("--:--:--");
  useEffect(() => {
    const fmt = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "UTC",
      hour12: false,
    });
    const tick = () => setNow(fmt.format(new Date()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return now;
}

function CornerTick({ className }: { className: string }) {
  return <span className={`absolute size-3 border-ink-600/70 ${className}`} />;
}

export function Hud() {
  const utc = useUtcClock();
  return (
    <div className="pointer-events-none fixed inset-0 z-40 hidden md:block">
      {/* viewport corner ticks */}
      <CornerTick className="left-3 top-3 border-l border-t" />
      <CornerTick className="right-3 top-3 border-r border-t" />
      <CornerTick className="bottom-3 left-3 border-b border-l" />
      <CornerTick className="bottom-3 right-3 border-b border-r" />

      {/* telemetry, bottom-left */}
      <div className="absolute bottom-5 left-6 flex flex-col gap-1 font-mono text-[0.65rem] uppercase tracking-[0.18em] text-ink-500">
        <span className="flex items-center gap-2">
          <span className="relative flex size-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-success opacity-75" />
            <span className="relative inline-flex size-1.5 rounded-full bg-success" />
          </span>
          STATUS · FIELD-READY
        </span>
        <span>33.6189°N 117.9298°W · NEWPORT BEACH</span>
        <span className="text-ink-600">UTC {utc}</span>
      </div>

      {/* vertical edge label, right */}
      <span className="absolute right-5 top-1/2 -translate-y-1/2 rotate-90 font-mono text-[0.6rem] uppercase tracking-[0.4em] text-ink-700">
        Forward Deployed Engineering
      </span>
    </div>
  );
}
